import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DeactivationStatusApi } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const DeactivationStatus = createAsyncThunk('get/deactivationStatus', DeactivationStatusApi);

export const DeactivationStatusSlice = createSlice({
	name: 'deactivationStatus',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[DeactivationStatus.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[DeactivationStatus.rejected.toString()]: setAPIError,
		[DeactivationStatus.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[DeactivationStatusSlice.name]: ReturnType<typeof DeactivationStatusSlice.reducer>;
}

interface IParams {
	deviceSerial?: string;
}

export const deactivationStatusSelector = (state: IStates): any => {
	return state[DeactivationStatusSlice.name] || {};
};

export const useDeactivationStatus = (): any => useSelector(deactivationStatusSelector);

export const getDeactivationStatus =
	(params: IParams) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(DeactivationStatus({ ...params }));
		return;
	};

export const resetDeactivationStatus =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(DeactivationStatusSlice.actions.RESET());
		return;
	};
